import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import CharityTile from 'components/charity_tile'
import styles from './crowdfunding_nonprofit.less'
import { getI18n, getI18nBase } from 'client/i18n'
import { HeadingText, Col, CaptionText } from '@paypalcorp/pp-react'
import { trackEventNameClick } from 'lib/fpti_analytics'
import Typeahead from 'components/common/type_ahead_search'

export const I18N_CONTEXT =
  'components/pages/crowdfunding/crowdfunding_nonprofit'
export const I18N_CONTEXT_TITLE = 'components/pages/crowdfunding/pool_nonprofit'

const i18n = getI18n(I18N_CONTEXT)
const i18nBase = getI18nBase(I18N_CONTEXT)
const i18nBaseTitle = getI18nBase(I18N_CONTEXT_TITLE)

class NonProfitPage extends React.Component {
  static propTypes = {
    featuredCharities: PropTypes.arrays,
    selectCharity: PropTypes.func,
    getCharities: PropTypes.func.isRequired,
    disclaimer: PropTypes.string,
  }

  getOptions = (options, userText) => {
    if (!userText) {
      return []
    }
    return this.props
      .getCharities({
        search_all: userText,
        page: 1,
        page_size: 30,
      })
      .then(this.getResponse)
  }

  getResponse = resp => {
    return resp || []
  }

  getSelectedItem = item => {
    trackEventNameClick({
      event_name: 'dw_giving_browse_fundraiser_charity_selection_pressed',
      charity_name: item.name,
      npid: item.nonprofit_id,
    })
    this.props.selectCharity(item)
  }

  setItemDecoration(item) {
    return (
      <React.Fragment>
        <div
          styleName="thumbnail"
          style={{
            background: `url(${
              item.logo_url
            }) center center / contain no-repeat`,
          }}
        />
        <p styleName="item-text">
          {item.name}
          <div>{`${item.address.city}, ${item.address.country_code}`}</div>
        </p>
      </React.Fragment>
    )
  }

  render() {
    const { featuredCharities, selectCharity } = this.props
    const renderTiles = arrayOfCharities => {
      return arrayOfCharities.map((charity, index) => {
        return (
          <Col
            key={index}
            onClick={() =>
              trackEventNameClick({
                event_name:
                  'dw_giving_find_fundraiser_charity_recommendation_pressed',
                charity_name: charity && charity.name,
                npid: charity && charity.nonprofit_id,
              })
            }
          >
            <CharityTile
              selectCharity={selectCharity}
              key={index}
              slogan={charity.slogan}
              name={charity.name}
              npid={charity.nonprofit_id}
              logo_url={charity.logo_url}
              charity={charity}
            />
          </Col>
        )
      })
    }
    return (
      <div>
        <HeadingText size="md" styleName="title">
          {i18nBaseTitle('title')}
        </HeadingText>
        <div
          styleName="textbox-wrapper"
          onClick={() =>
            trackEventNameClick({
              event_name: 'dw_giving_find_fundraiser_charity_search_pressed',
              flow: 'GENEROSITY_NETWORK_CHARITIES',
            })
          }
        >
          <Typeahead
            name="charitySearch"
            getOptions={this.getOptions}
            getSelectedItem={this.getSelectedItem}
            setItemDecoration={cssModules(this.setItemDecoration, styles)}
            delay={1000}
            datasource="name"
            label={i18nBase('search_placeholder')}
          />
        </div>
        {featuredCharities.length > 0 && (
          <div styleName="featured-charities">
            <HeadingText size="sm" styleName="featured-charities-header">
              {i18n('charity_header')}
            </HeadingText>
            <div styleName="featured-tiles">
              {renderTiles(featuredCharities, 'featured')}
            </div>
          </div>
        )}
        <CaptionText
          styleName="footer-text"
          dangerouslySetInnerHTML={{ __html: this.props.disclaimer }}
          onClick={() =>
            trackEventNameClick({
              event_name: 'dw_giving_find_fundraiser_charity_terms_pressed',
              flow: 'GENEROSITY_NETWORK_CHARITIES',
            })
          }
        />
      </div>
    )
  }
}
export default cssModules(NonProfitPage, styles)
